import { EmailSender } from '../iCourrier';

export class ExchangeMailListColumn {
  mailId: string;
  dateMail: string;
  expediteur: string;
  expediteurEmail: string;
  subject: string;
  exchangeMailChargeId: number;
  exchangeMailCharge: {
    id: number;
    mailIdentifier: string;
    contactId: number;
    datePriseEnMain: string;
  };
  date: string;
  dateDocument: string;
  id: string;
  typeExchange: boolean;
  typeEntrantSortant: string;

  // columns fields
  a: string;
  borderColor: string;
  exchangeMailChargeLabel: string;

  // More datas
  emailObject: ExchangeEmail;
  token: string;
}

export class ExchangeEmail {
  //Equivalent to EmailFileDetails

  public fileName: string;
  public fileContentType: string;
  public fileExtension: string;
  public id: string;
  public subject: string;
  public sentOnUtcDateTime: string;
  public sender: EmailSender;
  public recipients: {
    email: string;
    displayName: string;
    type: string;
    addressType: string;
  }[];
  public attachments: {
    filename: string;
    extention: string;
  }[];
  public bodyText: string;
  public bodyHtml: string;
  public bodyRtf: string;

  public fileSize?: string;
  constructor(data?) {
    Object.assign(this, data);
  }
}

export class Exchange {
  public exchangeAdress: string;
  public exchangeAdressLogin: string;
  public exchangeAdressPassword: string;
  public exchangeDefaultQuantity: string;
  public exchangeMasquerPerso: string;
  public exchangeNomExpediteur: string;
  public exchangeReplyToAdress: string;
  public exchangeReplyToName: string;
  public globalMailbox: string;
  public globalMailboxCredentials: string;
  public hidePersonalBox: boolean;
  public sharedMailboxes: string[] = [];
  constructor(data?) {
    Object.assign(this, data);
    this.exchangeAdressPassword = 'unfauxmotdepasse';
    // Si le tableau contient uniquement une entrée avec '', alors tableau vide
    if (this.sharedMailboxes.length === 1) {
      if (this.sharedMailboxes[0] === '') {
        this.sharedMailboxes = [];
      }
    }
  }
}
